export default {
  state: {
    v2CurrentPermission: {
      //企业
      COMPANY_DETAIL: false,
      COMPANY_DOWNLOAD: false,
      //并购
      CMTRANS_DETAIL: false,
      CMTRANS_DOWNLOAD: false,
      //宏观
      MACRO_DETAIL: false,
      MACRO_DOWNLOAD: false,
      //行业
      INDUSTRY_DETAIL: false,
      INDUSTRY_DOWNLOAD: false,

      //行业数据源
      CUSTEEL_DATA: false, //钢铁
      FOODSTUFF_DATA: false,//食品土特产
      AGRICULTURAL_DATA: false //农产品
    },
    v2CountryList: []
  },
  mutations: {
    setV2CurrentPermission(state, keys) {
      keys.forEach(key => {
        state.v2CurrentPermission[key] = true;
      })
    },

    setV2CountryList(state, lists) {
      state.v2CountryList = lists;
    }
  }
}